import { useMemo } from 'react';

import * as styles from './AudioPlayer.css';

interface Props {
  /** Static play pill fill color resolved from text tone selection. */
  backgroundColor?: string;
  /** Static play icon URL resolved from text tone selection. */
  iconUrl?: string;
}

const PLAY_BUTTON_ICON_PX = 14;

/**
 * Static play icon pill so write mode can mirror the email send appearance
 * (28×28, 14px icon — see email `PLAY_BUTTON_*` in podcast embed component).
 */
const DEFAULT_PLAY_ICON_URL = 'https://media.beehiiv.com/static_assets/bhv_podEp_play_bk.png';

export function EmailPlayButtonReference({ backgroundColor, iconUrl }: Props) {
  const resolvedBackgroundColor = useMemo(() => {
    if (typeof backgroundColor !== 'string' || backgroundColor.trim() === '') {
      return '#F9FAFB';
    }
    return backgroundColor.trim();
  }, [backgroundColor]);
  const resolvedIconUrl = useMemo(() => {
    if (typeof iconUrl !== 'string' || iconUrl.trim() === '') {
      return DEFAULT_PLAY_ICON_URL;
    }
    return iconUrl.trim();
  }, [iconUrl]);

  return (
    <span
      className={styles.emailPlayReference}
      style={{
        backgroundColor: resolvedBackgroundColor,
        border: `1px solid ${resolvedBackgroundColor}`,
      }}
      role="img"
      aria-label="Email play button preview (not interactive)"
    >
      <img
        src={resolvedIconUrl}
        alt=""
        width={PLAY_BUTTON_ICON_PX}
        height={PLAY_BUTTON_ICON_PX}
        style={{ display: 'block', width: `${PLAY_BUTTON_ICON_PX}px`, height: 'auto' }}
      />
    </span>
  );
}
